// in case not included in product page, replaced by v2
if (document.querySelector('#product')) {
    /************
     Product Swiper
     ************/

// setup product swiper
    let productImages = new Swiper("#productSwiper");

// thumbnail
    document.querySelectorAll(".productThumbnail").forEach(function (element) {
        element.addEventListener("click", function () {
            // determine index
            let index = getElIndex(this);

            // change active slide
            productImages.slideTo(index);
        });
    });

    /****************
     Image Lightbox (desktop)
     *****************/

    const galleryImages = [...document.querySelectorAll('.productSwiperImage')];

    if (galleryImages.length && !galleryImages[0].dataset.lightboxInit) {
        galleryImages.forEach(img => { img.dataset.lightboxInit = '1'; });
        // fullscreen deserves a sharper rendition; the inline gallery is a
        // 1000x1000 center crop, so also drop the height/crop for full aspect
        const lightboxHiRes = src =>
            /cdn\.shopify\.com|\/cdn\/shop\//.test(src) && /width=\d+/.test(src)
                ? src.replace(/width=\d+/, 'width=2048').replace(/&height=\d+/, '').replace(/&crop=[a-z]+/, '')
                : src;

        const lightboxHandle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
        const lightboxTrack = (event, data) => {
            (window.dataLayer = window.dataLayer || []).push({event, product_handle: lightboxHandle, ...data});
            if (typeof window.clarity === 'function') window.clarity('event', event);
        };

        const lightbox = document.createElement('div');
        lightbox.className = 'productLightbox';
        lightbox.setAttribute('role', 'dialog');
        lightbox.setAttribute('aria-modal', 'true');
        lightbox.setAttribute('aria-label', 'Product image gallery');
        lightbox.innerHTML = `
            <button class="productLightboxClose" aria-label="Close">&times;</button>
            <button class="productLightboxArrow prev" aria-label="Previous image">&#10094;</button>
            <img class="productLightboxImage" alt="">
            <button class="productLightboxArrow next" aria-label="Next image">&#10095;</button>
            <div class="productLightboxCounter" aria-live="polite"></div>
            <div class="productLightboxHint">Double-tap to zoom</div>
        `;
        document.body.appendChild(lightbox);

        if (galleryImages.length < 2) {
            lightbox.querySelectorAll('.productLightboxArrow, .productLightboxCounter').forEach(el => el.style.display = 'none');
        }

        const lightboxImage = lightbox.querySelector('.productLightboxImage');
        const lightboxCounter = lightbox.querySelector('.productLightboxCounter');
        const lightboxCloseBtn = lightbox.querySelector('.productLightboxClose');
        let lightboxIndex = 0, lightboxTrigger = null, lightboxViewed = 0;
        let lightboxZoomed = false, lightboxZoomRect = null;
        let prevBodyOverflow = '', prevBodyPadRight = '';

        function setLightboxZoom(on, x, y) {
            lightboxZoomed = on;
            if (on) {
                lightboxZoomRect = lightboxImage.getBoundingClientRect(); // pre-scale rect for stable panning
                lightboxImage.style.transformOrigin = `${x}% ${y}%`;
                lightboxImage.classList.add('is-zoomed');
            } else {
                lightboxImage.classList.remove('is-zoomed');
                lightboxZoomRect = null;
            }
            // clear any touch pinch/pan state as well
            tScale = 1; tX = 0; tY = 0;
            lightboxImage.style.transform = '';
        }

        function showLightboxImage(index) {
            lightboxIndex = (index + galleryImages.length) % galleryImages.length;
            setLightboxZoom(false);
            lightboxImage.classList.add('is-loading');
            lightboxImage.onload = () => lightboxImage.classList.remove('is-loading');
            lightboxImage.onerror = () => {
                lightboxImage.classList.remove('is-loading');
                if (lightboxImage.src !== galleryImages[lightboxIndex].src) lightboxImage.src = galleryImages[lightboxIndex].src;
            };
            lightboxImage.src = lightboxHiRes(galleryImages[lightboxIndex].src);
            lightboxImage.alt = galleryImages[lightboxIndex].alt;
            lightboxCounter.textContent = `${lightboxIndex + 1} / ${galleryImages.length}`;
            lightboxViewed++;
            // prefetch neighbours so arrow navigation never flashes
            if (galleryImages.length > 1) {
                [lightboxIndex + 1, lightboxIndex - 1].forEach(n => {
                    new Image().src = lightboxHiRes(galleryImages[(n + galleryImages.length) % galleryImages.length].src);
                });
            }
        }

        function openLightbox(index) {
            lightboxTrigger = galleryImages[index];
            lightboxViewed = 0;
            pinchTracked = false;
            showLightboxImage(index);
            lightbox.classList.add('active');
            prevBodyOverflow = document.body.style.overflow;
            prevBodyPadRight = document.body.style.paddingRight;
            const gutter = window.innerWidth - document.documentElement.clientWidth;
            if (gutter > 0) document.body.style.paddingRight = `${gutter}px`;
            document.body.style.overflow = 'hidden';
            // the phone's back button should close the lightbox, not leave the page
            if (!(history.state && history.state.productLightbox)) {
                try { history.pushState({productLightbox: true}, ''); } catch (err) {}
            }
            // focus after the fade makes the dialog visible
            requestAnimationFrame(() => requestAnimationFrame(() => lightboxCloseBtn.focus()));
            lightboxTrack('pdp_lightbox_open', {image_index: lightboxIndex + 1, image_count: galleryImages.length});
        }

        function closeLightbox(method) {
            tapStart = null;
            lastTapTime = 0;
            lightbox.classList.remove('active');
            setLightboxZoom(false);
            document.body.style.overflow = prevBodyOverflow;
            document.body.style.paddingRight = prevBodyPadRight;
            // land the inline gallery on the image the user was viewing
            productImages.slideTo?.(lightboxIndex);
            lightboxTrigger?.focus({preventScroll: true});
            if (method !== 'back' && history.state && history.state.productLightbox) {
                suppressNextPop = true;
                try { history.back(); } catch (err) {}
            }
            lightboxTrack('pdp_lightbox_close', {method: method || 'button', images_viewed: lightboxViewed});
        }

        let suppressNextPop = false;
        window.addEventListener('popstate', e => {
            if (suppressNextPop) { suppressNextPop = false; return; }
            if (lightbox.classList.contains('active')) { closeLightbox('back'); return; }
            // stale lightbox entry re-entered via Forward: consume it silently
            if (e.state && e.state.productLightbox) { suppressNextPop = true; try { history.back(); } catch (err) {} }
        });

        galleryImages.forEach((img, index) => {
            img.setAttribute('tabindex', '0');
            img.setAttribute('role', 'button');
            img.setAttribute('aria-label', `Open image ${index + 1} fullscreen`);
            img.addEventListener('click', () => openLightbox(index));
            img.addEventListener('keydown', e => {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                if (!window.matchMedia('(min-width: 801px)').matches) return;
                e.preventDefault();
                openLightbox(index);
            });
        });

        lightboxImage.setAttribute('draggable', 'false');

        // click-to-magnify with cursor panning (mouse; touch has its own gestures)
        lightboxImage.addEventListener('click', e => {
            if (e.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
            if (lightboxZoomed) { setLightboxZoom(false); return; }
            const r = lightboxImage.getBoundingClientRect();
            setLightboxZoom(true, (e.clientX - r.left) / r.width * 100, (e.clientY - r.top) / r.height * 100);
            lightboxTrack('pdp_lightbox_zoom', {image_index: lightboxIndex + 1});
        });
        lightboxImage.addEventListener('mousemove', e => {
            if (!lightboxZoomed || !lightboxZoomRect) return;
            const x = Math.min(100, Math.max(0, (e.clientX - lightboxZoomRect.left) / lightboxZoomRect.width * 100));
            const y = Math.min(100, Math.max(0, (e.clientY - lightboxZoomRect.top) / lightboxZoomRect.height * 100));
            lightboxImage.style.transformOrigin = `${x}% ${y}%`;
        });

        /* ---- touch gestures: swipe to browse, double-tap / pinch to zoom, drag to pan ---- */
        let tScale = 1, tX = 0, tY = 0;
        const touchPts = {};
        let pinchStartDist = 0, pinchStartScale = 1, lastTapTime = 0, tapStart = null, pinchTracked = false;
        const lightboxHint = lightbox.querySelector('.productLightboxHint');

        const applyTouch = () => {
            lightboxImage.style.transform = tScale > 1
                ? `translate(${tX}px, ${tY}px) scale(${tScale})`
                : '';
        };

        const clampPan = () => {
            const maxX = lightboxImage.offsetWidth * (tScale - 1) / 2;
            const maxY = lightboxImage.offsetHeight * (tScale - 1) / 2;
            tX = Math.min(maxX, Math.max(-maxX, tX));
            tY = Math.min(maxY, Math.max(-maxY, tY));
        };

        lightboxImage.addEventListener('pointerdown', e => {
            if (e.pointerType !== 'touch') return;
            touchPts[e.pointerId] = {x: e.clientX, y: e.clientY};
            const ids = Object.keys(touchPts);
            if (ids.length === 1) {
                tapStart = {x: e.clientX, y: e.clientY, t: Date.now()};
            } else if (ids.length === 2) {
                const a = touchPts[ids[0]], b = touchPts[ids[1]];
                pinchStartDist = Math.hypot(a.x - b.x, a.y - b.y);
                pinchStartScale = tScale;
                lightboxImage.style.transition = 'none'; // live-track fingers, no easing lag
                tapStart = null;
            }
        });

        lightboxImage.addEventListener('pointermove', e => {
            if (e.pointerType !== 'touch' || !touchPts[e.pointerId]) return;
            const prev = touchPts[e.pointerId];
            touchPts[e.pointerId] = {x: e.clientX, y: e.clientY};
            const ids = Object.keys(touchPts);
            if (ids.length === 2 && pinchStartDist > 0) {
                const a = touchPts[ids[0]], b = touchPts[ids[1]];
                tScale = Math.min(3.5, Math.max(1, pinchStartScale * Math.hypot(a.x - b.x, a.y - b.y) / pinchStartDist));
                if (tScale > 1.05 && !pinchTracked) {
                    pinchTracked = true;
                    if (lightboxHint) lightboxHint.style.display = 'none';
                    lightboxTrack('pdp_lightbox_zoom', {image_index: lightboxIndex + 1});
                }
                clampPan();
                applyTouch();
            } else if (ids.length === 1 && tScale > 1) {
                tX += e.clientX - prev.x;
                tY += e.clientY - prev.y;
                clampPan();
                applyTouch();
            }
        });

        const touchEnd = e => {
            if (e.pointerType !== 'touch' || !touchPts[e.pointerId]) return;
            if (!lightbox.classList.contains('active')) { delete touchPts[e.pointerId]; return; }
            delete touchPts[e.pointerId];
            if (!Object.keys(touchPts).length) {
                lightboxImage.style.transition = '';
                if (tScale < 1.05 && tScale !== 1) { tScale = 1; tX = 0; tY = 0; applyTouch(); }
            }
            if (!tapStart) return;
            const dx = e.clientX - tapStart.x, dy = e.clientY - tapStart.y;
            const quick = Date.now() - tapStart.t < 350;
            tapStart = null;
            // swipe to browse (only when not zoomed in)
            if (galleryImages.length > 1 && tScale === 1 && quick && Math.abs(dx) > 60 && Math.abs(dy) < 80) {
                showLightboxImage(dx < 0 ? lightboxIndex + 1 : lightboxIndex - 1);
                lightboxTrack('pdp_lightbox_navigate', {image_index: lightboxIndex + 1});
                return;
            }
            // double-tap to zoom
            if (Math.abs(dx) < 20 && Math.abs(dy) < 20) {
                const now = Date.now();
                if (now - lastTapTime < 350) {
                    if (tScale > 1) {
                        tScale = 1; tX = 0; tY = 0;
                    } else {
                        const r = lightboxImage.getBoundingClientRect();
                        tScale = 2.5;
                        tX = (r.left + r.width / 2 - e.clientX) * tScale;
                        tY = (r.top + r.height / 2 - e.clientY) * tScale;
                        clampPan();
                        if (lightboxHint) lightboxHint.style.display = 'none';
                        lightboxTrack('pdp_lightbox_zoom', {image_index: lightboxIndex + 1});
                    }
                    applyTouch();
                    lastTapTime = 0;
                } else {
                    lastTapTime = now;
                }
            }
        };
        lightboxImage.addEventListener('pointerup', touchEnd);
        lightboxImage.addEventListener('pointercancel', e => {
            if (e.pointerType !== 'touch') return;
            delete touchPts[e.pointerId];
            if (!Object.keys(touchPts).length) lightboxImage.style.transition = '';
        });

        lightboxCloseBtn.addEventListener('click', () => closeLightbox('button'));
        lightbox.querySelector('.productLightboxArrow.prev').addEventListener('click', () => { showLightboxImage(lightboxIndex - 1); lightboxTrack('pdp_lightbox_navigate', {image_index: lightboxIndex + 1}); });
        lightbox.querySelector('.productLightboxArrow.next').addEventListener('click', () => { showLightboxImage(lightboxIndex + 1); lightboxTrack('pdp_lightbox_navigate', {image_index: lightboxIndex + 1}); });
        lightbox.addEventListener('click', e => {
            if (e.target === lightbox) closeLightbox('backdrop');
        });

        // keep Tab inside the dialog while it is open
        lightbox.addEventListener('keydown', e => {
            if (e.key !== 'Tab') return;
            const focusables = [...lightbox.querySelectorAll('button')].filter(b => getComputedStyle(b).display !== 'none');
            if (!focusables.length) return;
            const first = focusables[0], last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });

        document.addEventListener('keydown', e => {
            if (!lightbox.classList.contains('active')) return;
            if (e.key === 'Escape') closeLightbox('escape');
            if (galleryImages.length < 2) return;
            if (e.key === 'ArrowLeft') { showLightboxImage(lightboxIndex - 1); lightboxTrack('pdp_lightbox_navigate', {image_index: lightboxIndex + 1}); }
            if (e.key === 'ArrowRight') { showLightboxImage(lightboxIndex + 1); lightboxTrack('pdp_lightbox_navigate', {image_index: lightboxIndex + 1}); }
        });
    }

    /*******************
     Product Subscription
     ********************/
    let subscription = true;
// check for subscription exemption
    document.querySelector('#productCheckout').classList.contains('noSub') ? subscription = false : null;

    let subscriptionID = document.querySelector('#productAddSubSelect')?.value;

// if one-time is selected subscription is false
    document.querySelectorAll('.productAddSubItem').forEach(el => {
        el.addEventListener('click', function () {
            if (this.classList.contains('subscribe')) {
                this.parentElement.classList.add('active');
                subscription = true;
            } else {
                this.parentElement.classList.remove('active');
                subscription = false;
            }
            updatePricingPerBottle();
        })
    })

// update the price per bottle and serving as compared to subscription price
    function updatePricingPerBottle() {
        document.querySelectorAll('.productVariantSideStack').forEach(el => {
            subscription === true ? el.classList.add('active') : el.classList.remove('active');
        })
        const activeInput = document.querySelector('.productVariant.active input');
        let oTPSavings = "";
        if (activeInput.dataset.quantity === "3") {
            oTPSavings = " - 5% Off"
        } else if (activeInput.dataset.quantity === "5") {
            oTPSavings = " - 12% Off"
        }
        if (subscription) {
            productATC.innerHTML = `Subscribe & Save - ${activeInput.dataset.saved}% Off 🛒`;
        } else {
            productATC.innerHTML = `Add to Cart${oTPSavings} 🛒`;
        }
    }

// initial pricing
    updatePricingPerBottle();

// keep track of current plan id
    document.querySelector('#productAddSubSelect')?.addEventListener('change', function () {
        subscriptionID = this.value;
    })

    /**************
     Product FAQ
     ***************/

    document.querySelectorAll('.productFaqQuestion').forEach((el) => {
        el.addEventListener('click', function () {
            this.parentNode.classList.toggle('active');
        })
    })

    /**************
     Product Variants
     ***************/

// initial variant
    let variantInput = document.querySelector('.productVariant.active');
// update active variant on input changes
    document.querySelectorAll(".productVariant").forEach(function (element) {
        element.addEventListener("change", function () {
            // change active variant label
            document.querySelector('.productVariant.active').classList.remove('active');
            this.classList.add('active');

            // get input
            variantInput = this.querySelector('.productVariantID');

            // update atc drop shadow
            document.querySelector('#productATC').setAttribute("position", variantInput.dataset.position);

            // update quantity
            quantity = parseInt(variantInput.dataset.quantity);

            // get variant id
            let activeVariantID = variantInput.dataset.id;

            // update savings amount
            document.querySelectorAll('.productAddSubInfoItemSavings').forEach(el => {
                el.classList.remove('active');
                if (el.dataset.id === activeVariantID) el.classList.add('active');
            })

            // update text on ATC button
            updatePricingPerBottle();
        });
    })

    /****************
     * Product Quantity
     ******************/

    let quantity = parseInt(variantInput.querySelector('.productVariantID').dataset.quantity);

    /**************
     Product ATC
     ***************/

    document.querySelector("#productATC").addEventListener("click", async function () {
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                // if subscription is chosen, use active id
                selling_plan: subscription ? subscriptionID : null
            }]
        };

        // add product
        await addProduct(formData);

        // open cart
        await openCart();

        this.classList.remove("loading");
    });

    /**************
     Product Upsell
     ***************/

    document.querySelectorAll(".productUpsellButtonAdd").forEach(el => {
        el.addEventListener('click', async function (e) {
            // button wrapped in anchor tag
            e.preventDefault();

            // if ATC button is subscribe
            let sellingPlan = this.classList.contains('subscribe');
            let id = this.parentElement.dataset.id;
            let subscription = this.parentElement.dataset.subscribe;

            this.classList.add("loading");

            let formData = {
                items: [{
                    quantity: 1,
                    id: id,
                    // if subscription is chosen, use active id
                    selling_plan: sellingPlan ? subscription : null
                }]
            };

            // add product
            await addProduct(formData);

            // open cart
            await openCart();

            this.classList.remove("loading");

        })
    })
}